import React from 'react';
import styles from './NextButton.module.scss';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { connect } from 'react-redux';

//redux stuff
import { nextActiveStep } from '../../../redux/agreement/actions';

const Nextbutton = ({ nextActiveStep, form, type, disabled }) => {
	return (
		<button
			className={styles.nextButton}
			form={form}
			type={type}
			disabled={disabled}
		>
			Next <ArrowForwardIosIcon />
		</button>
	);
};

export default connect(null, { nextActiveStep })(Nextbutton);
